import { shallowMount } from "@vue/test-utils";
import WorkActivitySujetoObligado from "@/components/core/WorkActivitySujetoObligado";

describe("WorkActivitySujetoObligado component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(WorkActivitySujetoObligado);
  });

  it("Renders del component WorkActivitySujetoObligado", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
